import type {
  AssessmentAnswers,
  AssessmentSubmissionBody,
  AssessmentSubmissionParams,
} from "../types";

/**
 * Converts form values to the complete request body format expected by the backend.
 * Based on SurveyJS format: https://surveyjs.io/form-library/documentation/access-and-modify-survey-results
 */
export function adaptDataForSubmission(
  params: AssessmentSubmissionParams,
): AssessmentSubmissionBody {
  const { assessmentDefinitionId, assessmentDefinitionVersion, formData, taskId } = params;

  const answers = Object.entries(formData).reduce<AssessmentAnswers>((acc, [key, answer]) => {
    if (answer === undefined || answer === null || answer === "") return acc;

    /** Handle array values (checkbox questions) */
    if (Array.isArray(answer)) {
      acc[key] = answer;

      return acc;
    }

    /** Handle numeric strings from rating questions - convert to numbers */
    const numValue = Number(answer);

    if (!isNaN(numValue)) {
      acc[key] = numValue;
    } else {
      /** Keep as string for other question types (radiogroup, text, etc.) */
      acc[key] = String(answer);
    }

    return acc;
  }, {});

  return {
    answers,
    assessment_definition_id: assessmentDefinitionId,
    assessment_definition_version: assessmentDefinitionVersion,
    task_id: taskId,
    version: 1,
  };
}
